import axios from 'axios';

// Allow overriding API base via env (CRA uses REACT_APP_*)
const envBase = process.env.REACT_APP_API_BASE_URL;
const defaultBase = '/menuwise/api/v1';
const resolvedBaseURL = (envBase && envBase.trim().length > 0) ? envBase : defaultBase;

const apiClient = axios.create({
    baseURL: resolvedBaseURL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
    },
    timeout: 60000, // 60 second timeout
});

// Add request interceptor for debugging
apiClient.interceptors.request.use(
    config => {
        console.log('API Request:', {
            method: config.method,
            url: config.url,
            baseURL: config.baseURL,
            fullURL: `${config.baseURL}${config.url}`,
            data: config.data,
            headers: config.headers
        });
        // Ensure cookies are sent when cross-origin (server must set CORS allow-credentials)
        config.withCredentials = true;
        return config;
    },
    error => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// Add response interceptor for debugging
apiClient.interceptors.response.use(
    response => {
        console.log('API Response:', {
            status: response.status,
            url: response.config.url,
            data: response.data
        });
        return response;
    },
    error => {
        console.error('API Error:', {
            message: error.message,
            status: error.response?.status,
            statusText: error.response?.statusText,
            url: error.config?.url,
            data: error.response?.data,
            isTimeout: error.code === 'ECONNABORTED',
            isNetworkError: error.code === 'ERR_NETWORK'
        });
        
        // Provide more specific error messages for timeouts
        if (error.code === 'ECONNABORTED') {
            error.message = 'Request timeout: The server took too long to respond. Please try again.';
        } else if (error.code === 'ERR_NETWORK') {
            error.message = 'Network error: Unable to connect to the server. Please check your internet connection.';
        }
        
        return Promise.reject(error);
    }
);

export { apiClient, resolvedBaseURL as menuwiseApiBaseURL };